import {
  EducatorsCustomClassesClassIndex,
  EducatorsListingProfileItem,
} from "@/types/serializers"
import { CustomClassFormValues } from "@/types/teachers/customClasses"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  classes: Array<{
    listing_profile: EducatorsListingProfileItem
    collection: Array<EducatorsCustomClassesClassIndex>
  }>
}
export const useIndexProps = () => useProps<IndexProps>()

export type NewProps = {
  custom_class: CustomClassFormValues
  states?: Array<{ label: string; value: number }>
  subjects?: Array<{ label: string; value: number }>
  state_id?: number
  personal_listing_profile_id: number
  personal_listing_profile_speciality_options: Array<SelectOption<number>>
  team_profile_options: Array<SelectOption>
}
export const useNewProps = () => useProps<NewProps>()

export type EditProps = {
  custom_class: CustomClassFormValues
  states?: Array<{ label: string; value: number }>
  subjects?: Array<{ label: string; value: number }>
  state_id?: number
  listing_profile_speciality_options: Array<SelectOption<number>>
  listing_profile_id: number
}
export const useEditProps = () => useProps<EditProps>()
